import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';

import { practitionersTranslationKeys } from '../../../../../translations';

import { ConfidentialDataAccessSelect } from './ConfidentialDataAccessCell.styled';
import { useTriggerLabelExtractor } from './ConfidentialDataAccessCell.hooks';
import { ConfidentialDataAccessFormBean, ConfidentialDataAccessOption } from './ConfidentialDataAccessCell.types';
import { useConfidentialAccessLevelUpdate } from './useConfidentialAccessLevelUpdate.hooks';
import { CONFIDENTIAL_DATA_ACCESS_OPTIONS } from './ConfidentialDataAccessCell.constants';

type ConfidentialDataAccessCellProps = {
   readonly initialValue: ConfidentialDataAccessOption;
   readonly practitionerId: number;
};

export const ConfidentialDataAccessCell = (props: ConfidentialDataAccessCellProps): ReactElement => {
   const { register, watch } = useFormController<ConfidentialDataAccessFormBean>({
      confidentialDataAccess: props.initialValue,
   });
   const triggerLabelExtractor = useTriggerLabelExtractor();

   useConfidentialAccessLevelUpdate({
      practitionerId: props.practitionerId,
      watch: watch,
   });

   return (
      <ConfidentialDataAccessSelect<ConfidentialDataAccessOption>
         testId={'confidentialDataAccess'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={register('confidentialDataAccess')}
         defaultValue={CONFIDENTIAL_DATA_ACCESS_OPTIONS[0]}
         compact
      >
         <ConfidentialDataAccessSelect.List items={CONFIDENTIAL_DATA_ACCESS_OPTIONS}>
            {(item) => (
               <ConfidentialDataAccessSelect.Item
                  item={item}
                  testId={item}
                  label={practitionersTranslationKeys.confidentialDataAccess[item]}
               />
            )}
         </ConfidentialDataAccessSelect.List>
      </ConfidentialDataAccessSelect>
   );
};
